import { useCartAddMultipleLineItems } from '@features/cart/api/cart-add-multiple-line-items'
import { Router } from 'next/router'
import { FC, useEffect } from 'react'
import { initVividworks } from './helpers'
import { mapToCartLineItems } from './thor'

type VividWorksProviderProps = {
  router: Router
}

const VividWorksProvider: FC<VividWorksProviderProps> = ({ router }) => {
  const { mutate } = useCartAddMultipleLineItems()

  useEffect(() => {
    // Only initialize on pages where the configurator is relevant
    // if (!router.pathname.includes('configurator')) return

    initVividworks({
      addToBasket: async (bundles, raw) => {
        const lineItems = mapToCartLineItems({
          bundles,
          raw,
        })

        mutate(lineItems)
      },
    })
  }, [mutate, router])

  return null
}

export default VividWorksProvider
